import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategoryGrid() {
  return (
    <section className="bg-background-100/50 py-12 md:py-16">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">
            影视分类
          </h2>
          <p className="text-sm text-foreground-500 mt-1">海量资源，按类查找</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className="group flex flex-col items-center gap-3 p-6 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <div className="text-center">
                <h3 className="text-sm font-semibold text-foreground-950">{cat.name}</h3>
                <p className="text-xs text-foreground-400 mt-0.5">{cat.count.toLocaleString()}部</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}